export interface FeedItem {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  tag: string;
  watchers: number;
  updates: number;
  time: string;
  hot: number;
  image: string;
  followed: boolean;
}

export const feedCategories = [
  { key: "全部", label: "全部围观" },
  { key: "影视娱乐", label: "影视娱乐" },
  { key: "体坛赛场", label: "体坛赛场" },
  { key: "音乐现场", label: "音乐现场" },
  { key: "数码科技", label: "数码科技" },
  { key: "社会现场", label: "社会现场" },
];

export const feedItems: FeedItem[] = [
  {
    id: "f-01",
    category: "影视娱乐",
    title: "新片首映礼红毯名场面盘点，谁才是全场话题中心？",
    excerpt:
      "首映礼刚落幕，红毯互动、主创现场金句、观众实时弹幕都被搬上了围观台。我们把高能瞬间按时间线整理成脉络，蹲后续的人可以直接从最精彩的部分接着看。",
    tag: "蹲后续中",
    watchers: 128640,
    updates: 12,
    time: "2小时前更新",
    hot: 98,
    image:
      "https://readdy.ai/api/search-image?query=red%20carpet%20premiere%20stage%20with%20bright%20spotlights%20and%20camera%20flashes%2C%20warm%20coral%20red%20and%20cream%20cream%20editorial%20flat%20vector%20illustration%2C%20festive%20gala%20atmosphere%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-movie&orientation=landscape",
    followed: true,
  },
  {
    id: "f-02",
    category: "体坛赛场",
    title: "联赛收官战前瞻：积分榜最后悬念今晚见分晓",
    excerpt:
      "最后一轮赛前数据、首发阵容猜测和球迷社区热议全部汇总到这里。胜负走向关系冠军归属，围观群众已备好板凳，就等开赛哨声，更新将实时跟到终场哨。",
    tag: "催更进行时",
    watchers: 96420,
    updates: 8,
    time: "今天 09:12",
    hot: 87,
    image:
      "https://readdy.ai/api/search-image?query=empty%20football%20stadium%20with%20green%20pitch%20under%20warm%20evening%20floodlights%2C%20leaf%20green%20and%20cream%20editorial%20flat%20vector%20illustration%2C%20sports%20matchday%20mood%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-sport&orientation=landscape",
    followed: true,
  },
  {
    id: "f-03",
    category: "音乐现场",
    title: "夏日音乐节阵容官宣，乐迷已经在评论区蹲守加场",
    excerpt:
      "第一波阵容公布后，讨论热度一路走高。压轴嘉宾的猜想、票价与场次信息、往期名场面回顾都整理在围观帖里，想抢票的可以直接抄作业，别错过加场通知。",
    tag: "新瓜开张",
    watchers: 85100,
    updates: 5,
    time: "昨天 21:40",
    hot: 76,
    image:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20sunset%20with%20colorful%20lights%20and%20crowd%20silhouettes%2C%20flesh%20orange%20and%20cream%20editorial%20flat%20vector%20illustration%2C%20lively%20concert%20mood%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-music&orientation=landscape",
    followed: false,
  },
  {
    id: "f-04",
    category: "数码科技",
    title: "新旗舰机发布会汇总：影像与续航谁更能打？",
    excerpt:
      "发布会全程脉络、参数对比表、首发真机上手评价一次看全。想换机的围观群众把关注点全押在了实测环节，后续续航与影像专项测评更新会持续跟进。",
    tag: "蹲后续中",
    watchers: 63980,
    updates: 9,
    time: "昨天 15:22",
    hot: 68,
    image:
      "https://readdy.ai/api/search-image?query=sleek%20smartphone%20product%20launch%20on%20glowing%20presentation%20podium%2C%20warm%20coral%20and%20cream%20editorial%20flat%20vector%20illustration%2C%20tech%20keynote%20mood%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-tech&orientation=landscape",
    followed: true,
  },
  {
    id: "f-05",
    category: "社会现场",
    title: "城市夜经济升温，烟火气摊位成了新晋打卡点",
    excerpt:
      "从出摊时间到排队攻略，从招牌菜测评到主理人故事，一篇帮你围观明白。现场实探还在继续，新摊位与限时活动更新中，跟紧大部队别走散。",
    tag: "更新提醒中",
    watchers: 50760,
    updates: 6,
    time: "前天 19:08",
    hot: 59,
    image:
      "https://readdy.ai/api/search-image?query=cozy%20night%20street%20food%20stall%20with%20warm%20lanterns%20and%20steaming%20food%2C%20flesh%20orange%20and%20cream%20editorial%20flat%20vector%20illustration%2C%20night%20economy%20lively%20mood%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-night&orientation=landscape",
    followed: false,
  },
  {
    id: "f-06",
    category: "影视娱乐",
    title: "口碑黑马剧大结局剧透贴，看完记得留个言",
    excerpt:
      "大结局讨论楼已经开了几十层，反转细节、人物去向和隐藏彩蛋都被扒了出来。还没看完的人注意绕道，想聊剧情、求解答的可以直接在围观帖里催更互动。",
    tag: "催更进行时",
    watchers: 112300,
    updates: 15,
    time: "前天 22:35",
    hot: 91,
    image:
      "https://readdy.ai/api/search-image?query=drama%20finale%20film%20still%20mood%20with%20theatre%20seats%20and%20projector%20light%20beam%2C%20cream%20and%20deep%20coral%20editorial%20flat%20vector%20illustration%2C%20cinematic%20climax%20mood%2C%20minimal%20modern%20style&width=800&height=600&seq=feed-drama&orientation=landscape",
    followed: true,
  },
];

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: "up" | "new" | "hot";
  category: string;
}

export const trendingRank: RankItem[] = [
  { id: "r1", rank: 1, title: "口碑黑马剧大结局讨论楼", tag: "影视娱乐", heat: 982000, trend: "up", category: "影视娱乐" },
  { id: "r2", rank: 2, title: "新片首映礼红毯名场面盘点", tag: "影视娱乐", heat: 863000, trend: "hot", category: "影视娱乐" },
  { id: "r3", rank: 3, title: "联赛收官战最后悬念今晚揭晓", tag: "体坛赛场", heat: 741000, trend: "up", category: "体坛赛场" },
  { id: "r4", rank: 4, title: "夏日音乐节首波阵容官宣", tag: "音乐现场", heat: 658000, trend: "new", category: "音乐现场" },
  { id: "r5", rank: 5, title: "新旗舰机发布会影像实测", tag: "数码科技", heat: 572000, trend: "down", category: "数码科技" },
  { id: "r6", rank: 6, title: "城市夜经济烟火摊位打卡记", tag: "社会现场", heat: 431000, trend: "hot", category: "社会现场" },
  { id: "r7", rank: 7, title: "跨界联名动画片周边抢购指南", tag: "影视娱乐", heat: 368000, trend: "down", category: "影视娱乐" },
  { id: "r8", rank: 8, title: "电竞决赛高光操作逐帧复盘", tag: "体坛赛场", heat: 299000, trend: "up", category: "体坛赛场" },
];